export const GROUP_BUDGET_BALANCE = `
  query GroupBudgetBalance($groupId: Int!, $meetingId: Int, $tenant_id: Int!) {
    groupBudgetBalance(groupId: $groupId, meetingId: $meetingId, tenant_id: $tenant_id) {
      __typename

      ... on GroupBudgetBalance {
        group_id
        initial_budget
        total_movements
        current_balance
        year
      }

      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
